import React, { useEffect, useState } from 'react';
import { Transition } from '@headlessui/react';
import { observer } from 'mobx-react';
import { Icon } from 'ui';

type Props = {
  reducedToast: IReducedToast;
  onClose: () => void;
};

const OPEN_TIME = 5000;

function ToastMessage({ reducedToast, onClose }: Props) {
  const [isShown, setIsShown] = useState(true);

  useEffect(() => {
    setTimeout(() => setIsShown(false), OPEN_TIME);
  }, []);

  return (
    <Transition
      appear
      show={isShown}
      enter="transform ease-out duration-300 transition"
      enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enterTo="translate-y-0 opacity-100 sm:translate-x-0"
      leave="transform ease-in duration-100 transition"
      leaveFrom="opacity-100 translate-x-0"
      leaveTo="opacity-0 translate-x-2"
      afterLeave={onClose}
      className="pointer-events-auto mb-3 w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
    >
      <div className="p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            {reducedToast.toast.type === 'success' && <Icon name="check-circle" color="green" />}
            {reducedToast.toast.type === 'error' && <Icon name="x-circle" color="red" />}
            {reducedToast.toast.type === 'warning' && <Icon name="exclamation-circle" color="yellow" />}
            {reducedToast.toast.type === 'info' && <Icon name="information-circle" color="blue" />}
          </div>
          <div className="ml-3 w-0 flex-1 pt-0.5">
            {reducedToast.toast.title && (
              <div className="flex">
                {reducedToast.count > 1 && (
                  <span className="mr-1 text-sm text-gray-700">{reducedToast.count}&times;</span>
                )}
                <p className="text-sm font-medium text-gray-900">{reducedToast.toast.title}</p>
              </div>
            )}
            <p className="mt-1 text-sm text-gray-500">{reducedToast.toast.description}</p>
          </div>
          <div className="ml-4 flex flex-shrink-0">
            <button
              type="button"
              className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              onClick={() => setIsShown(false)}
            >
              <span className="sr-only">{gettext('Close')}</span>
              <Icon name="x" />
            </button>
          </div>
        </div>
      </div>
    </Transition>
  );
}

export default observer(ToastMessage);
